import {
  MetricMapMapping,
  SourceMetricMap,
} from '@intelligence/components/DownloadCommon/DownloadPage/type/type';

const FONT_STYLE = { name: 'Calibri', size: 11 };
export const BOLD_FONT = { name: 'Calibri', size: 11, bold: true };
const ALIGN_CENTER = { vertical: 'middle', horizontal: 'center' };
const ALIGN_LEFT = { vertical: 'middle', horizontal: 'left' };
const BORDER_STYLE = { style: 'thin', color: { argb: 'FF000000' } };
const FONT_COLOR = { argb: 'FFFFFFFF' };
const FILL_STYLE = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: '212D53' },
};
export const defaultCellStyle = {
  font: FONT_STYLE,
  alignment: ALIGN_CENTER,
  numFmt: '@',
  border: {
    top: BORDER_STYLE,
    left: BORDER_STYLE,
    bottom: BORDER_STYLE,
    right: BORDER_STYLE,
  },
};
export const rowStyle = {
  font: {
    color: FONT_COLOR,
    ...FONT_STYLE,
  },
  alignment: ALIGN_CENTER,
  fill: FILL_STYLE,
  numFmt: '@',
};
export const styles: any = {
  0: {
    border: undefined,
    alignment: ALIGN_LEFT,
  },
  3: rowStyle,
};
const HrsWatched = 'hoursWatched';
const Airtime = 'airtime';
const PeakCCV = 'peak_ccv';
const AvgCCV = 'avg_ccv';

export const mobileDetailDownloadMetricMap: MetricMapMapping = {
  rv: 'revenue',
  dl: 'download',
  au: 'dau',
  mr: 'retention',
  lr: 'lifetime_retention',
  arpu: 'arpu',
  rp: 'rpd',
  cr: 'cumulative_revenue',
  cd: 'cumulative_downloads',
  hw: HrsWatched,
  stream_hw: HrsWatched,
  at: Airtime,
  stream_at: Airtime,
  pk: PeakCCV,
  stream_pk: PeakCCV,
  ac: AvgCCV,
  stream_ac: AvgCCV,
};

export const mobileDetailDownloadSourceMetricMap: SourceMetricMap = {
  appannie: {
    revenue: true,
    download: true,
    dau: true,
    retention: true,
    arpu: true,
    rpd: true,
    cumulative_revenue: true,
    cumulative_downloads: true,
  },
  sensortower: {
    revenue: true,
    download: true,
    dau: true,
    arpu: true,
    lifetime_retention: true,
  },
  ogdb: {
    revenue: true,
    download: true,
    dau: true,
    arpu: true,
  },
  stream: {
    [HrsWatched]: true,
    [Airtime]: true,
    [PeakCCV]: true,
    [AvgCCV]: true,
  },
};
export const metricTitleMap: { [key: string]: string } = {
  dau: 'DAU',
  revenue: 'Revenue',
  downloads: 'Downloads',
  download: 'Downloads',
  rpd: 'RPD',
  'cumulative revenue': 'Cumulative Revenue',
  'cumulative downloads': 'Cumulative Downloads',
  cumulative_revenue: 'Cumulative Revenue',
  cumulative_downloads: 'Cumulative Downloads',
  pcu: 'PCU',
  acu: 'ACU',
  mau: 'MAU',
  arpu: 'ARPU',
  mau_growth: 'MAU Growth',
  churn: 'Churn',
  lifetime_player: 'Lifetime Players',
  acquisition: 'Acquisition',
  player_share: 'Player Share',
  mau_new: 'MAU New',
  mau_returning: 'MAU Returning',
  avg_days_played: 'Avg Days Played',
  avg_daily_playtime: 'Avg Daily Playtime(mins)',
  avg_daily_sessions: 'Avg Daily Sessions',
  avg_playtime_per_session: 'Avg Playtime Per Session(mins)',
  avg_monthly_sessions: 'Avg Monthly Sessions',
  avg_monthly_playtime: 'Avg Monthly Playtime(hours)',
  time_spent_0H: 'Time Spent 0-1 hrs',
  time_spent_1H: 'Time Spent 1-5 hrs',
  time_spent_5H: 'Time Spent 5-10 hrs',
  time_spent_10H: 'Time Spent 10-25 hrs',
  time_spent_25H: 'Time Spent 25-50 hrs',
  time_spent_50H: 'Time Spent > 50 hrs',
  retention_d1: 'D1',
  retention_d2: 'D2',
  retention_d4: 'D4',
  retention_d7: 'D7',
  retention_d14: 'D14',
  retention_d28: 'D28',
  stickiness: 'Stickiness',
  total_hours: 'Total Hours',
  digitalRevenue: 'Digital Revenue',
  units: 'Units',
  digitalARPPU: 'Digital ARPPU',
  ast: 'AST',
  physicalRevenue: 'Physical Revenue',
  physical_units: 'Physical Units',
  week_sales: 'Sales',
  usd_price: 'Price',
  total_sales: 'Cumulative Sales',
  total_revenue: 'Cumulative Revenue',
  hoursWatched: 'Hours Watched',
  avgCCV: 'Avg CCV',
  peak_ccv: 'Peak CCV',
  airtime: 'Airtime',
  ytg: 'YouTube',
  facebook: 'Facebook Gaming',
  twitch: 'Twitch',
  switch: 'Switch',
  ps4: 'PS4',
  ps5: 'PS5',
  est_revenue: 'Steam Premium Revenue(VG Insights)',
  est_units: 'Steam Units(VG Insights)',
  est_price: 'Steam Price($)(VG Insights)',
  weighted_price: 'Weighted Price($)(VG Insights)',
  playtime: 'Avg.playtime(mins)',
  followers: 'Total Followers',
  players_by_country: 'Player by Country',
  vginsights_revenue: 'Steam Premium Revenue(VG Insights)',
  vginsights_unit: 'Steam Units(VG Insights)',
  vginsights_price: 'Steam Price($)(VG Insights)',
  vginsights_total_followers: 'Total Followers',
  steamfollowers: 'Steam Followers',
  steamreviews: 'Steam Reviews',
  est_cumulative_revenue: 'Cumulative Revenue(VG Insights)',
  est_cumulative_units: 'Cumulative Units(VG Insights)',
  lifetime_weighted_price: 'Lifetime Weighted Price($)(VG Insights)',
  japan_sales: 'Sales',
  japan_price: 'Price',
  japan_revenue: 'Revenue',
  cumulative_sales: 'Cumulative Revenue',
  gsd_digitalRevenue: 'Gsd Digital Revenue',
  gsd_digitalUnits: 'GSD Digital Units',
  gsd_physicalRevenue: 'Gsd Physical Revenue',
  gsd_physicalUnits: 'GSD Physical Units',
  meta_score: 'MetaCritic Score',
  ampere_d28: 'ampere_d28_title',
  'meta_score_Nintendo Switch': 'Metacritic Score-Nintendo Switch',
  meta_score_PC: 'Metacritic Score-PC',
  'meta_score_PlayStation 4': 'Metacritic Score-PlayStation 4',
  'meta_score_PlayStation 5': 'Metacritic Score-PlayStation 5',
  'meta_score_Wii U': 'Metacritic Score-Wii U',
  'meta_score_Xbox One': 'Metacritic Score-Xbox One',
  'meta_score_Xbox Series X/S': 'Metacritic Score-Xbox Series X/S',
  databrain__lifetime_total_revenue: 'Lifetime Total Revenue',
  databrain__lifetime_base_game_sales_units: 'Lifetime Base Game Sales Units',
  databrain__total_revenue: 'Total Revenue',
  databrain__base_game_sales_units: 'Base Game Sales Units',
  mscienceLifetimeDigitalRevenue: 'Mscience Lifetime Digital Revenue',
  mscienceLifetimeDigitalUnits: 'Mscience Lifetime Digital Units',
  // Gamalytic metrics
  gamalytic__pcu: 'Gamalytic Steam PCU',
  gamalytic__acu: 'Gamalytic Steam ACU',
  gamalytic__steamfollowers: 'Gamalytic Steam Followers',
  gamalytic__steamreviews: 'Gamalytic Steam Reviews',
  gamalytic__cumulative_reviews: 'Gamalytic Steam Total Reviews',
  gamalytic__est_revenue: 'Gamalytic Steam Revenue($)',
  gamalytic__est_cumulative_revenue: 'Gamalytic Steam Cumulative Revenue($)',
  gamalytic__est_units: 'Gamalytic Steam Units',
  gamalytic__est_cumulative_units: 'Gamalytic Steam Cumulative Units',
  gamalytic__wishlists: 'Gamalytic Steam Daily Wishlist',
  gamalytic__wishlists_total: 'Gamalytic Steam Lifetime Wishlist',
  gamalytic__est_price: 'Gamalytic Steam Price($)',
  gamalytic__lifetime_weighted_price: 'Gamalytic Steam Lifetime Weighted Price($)',
  gamalytic__players_by_country: 'Gamalytic Steam Players by Country',
  gamalytic__playtime: 'Gamalytic Steam Avg.playtime(hours)',
  gamalytic__followers: 'Gamalytic Steam Total Followers',
  // Alinea metrics
  alinea__pcu: 'Alinea Steam PCU',
  alinea__acu: 'Alinea Steam ACU',
  alinea__steamfollowers: 'Alinea Steam Followers',
  alinea__steamreviews: 'Alinea Steam Reviews',
  alinea__players: 'Alinea Steam Players',
  alinea__players_total: 'Alinea Steam Total Players',
  alinea__cumulative_reviews: 'Alinea Steam Total Reviews',
  alinea__positive: 'Alinea Steam Positive Reviews',
  alinea__cumulative_positive: 'Alinea Steam Total Positive Reviews',
  alinea__est_revenue: 'Alinea Steam Revenue($)',
  alinea__est_cumulative_revenue: 'Alinea Steam Cumulative Revenue($)',
  alinea__est_units: 'Alinea Steam Units',
  alinea__est_cumulative_units: 'Alinea Steam Cumulative Units',
  alinea__wishlists: 'Alinea Steam Daily Wishlist',
  alinea__wishlists_total: 'Alinea Steam Lifetime Wishlist',
  alinea__dau: 'Alinea DAU',
  alinea__mau: 'Alinea MAU',
  alinea__est_price: 'Alinea Steam Price($)',
  alinea__lifetime_weighted_price: 'Alinea Steam Lifetime Weighted Price($)',
  alinea__players_by_country: 'Alinea Steam Players by Country',
  alinea__ps_players_by_country: 'Alinea PS Players by Country',
  alinea__wishlists_by_country: 'Alinea Steam Wishlists by Countries',
  alinea__playtime: 'Alinea Steam Avg.playtime(mins)',
  alinea__followers: 'Alinea Steam Total Followers',
  source_steam__pcu: 'Steam PCU',
  source_steam__acu: 'Steam ACU',
  source_steam__hourly_ccu: 'Steam Hourly CCU',
  // Console Data (Alinea PS / Xbox)，与 pcConsoleGameMetric 保持一致
  alinea__ps_est_revenue: 'Alinea PS Revenue',
  alinea__ps_est_cumulative_revenue: 'Alinea PS Revenue Total',
  alinea__ps_est_units: 'Alinea PS Units',
  alinea__ps_est_cumulative_units: 'Alinea PS Units Total',
  alinea__ps_players: 'Alinea PS Players',
  alinea__ps_players_total: 'Alinea PS Total Players',
  alinea__ps_game_pass_players: 'Alinea PS Game Pass Players',
  alinea__ps_game_pass_players_total: 'Alinea PS Game Pass Total Players',
  alinea__ps_dau: 'Alinea PS DAU',
  alinea__ps_mau: 'Alinea PS MAU',
  alinea__xbox_est_revenue: 'Alinea Xbox Revenue',
  alinea__xbox_est_cumulative_revenue: 'Alinea Xbox Revenue Total',
  alinea__xbox_est_units: 'Alinea Xbox Units',
  alinea__xbox_est_cumulative_units: 'Alinea Xbox Units Total',
  alinea__xbox_players: 'Alinea Xbox Players',
  alinea__xbox_players_total: 'Alinea Xbox Total Players',
  alinea__xbox_game_pass_players: 'Alinea Xbox Game Pass Players',
  alinea__xbox_game_pass_players_total: 'Alinea Xbox Game Pass Total Players',
  alinea__xbox_dau: 'Alinea Xbox DAU',
  alinea__xbox_mau: 'Alinea Xbox MAU',
};
export const pcConsoleGameMetric = {
  digitalRevenue: 'Mscience Digital Revenue($)',
  revenue: 'NPD US Physical Revenue($)',
  gsd_digitalRevenue: 'GSD Digital Revenue(€)',
  gsd_physicalRevenue: 'GSD Physical Revenue(€)',
  est_revenue: 'Steam Premium Revenue($)',
  est_cumulative_revenue: 'Steam Cumulative Revenue($)',
  units: 'Mscience Digital Units',
  physical_units: 'NPD US Physical Units',
  est_units: 'Steam Units',
  est_cumulative_units: 'Steam Cumulative Units',
  pcu: 'Steam PCU',
  acu: 'Steam ACU',
  mau: 'MAU',
  digitalARPPU: 'Mscience US Digital ARPPU($)',
  ast: 'Mscience US Digital AST($)',
  est_price: 'Steam Price($)',
  lifetime_weighted_price: 'Lifetime Weighted Price($)',
  playtime: 'Steam Avg. Playtime(hours)',
  Mentions: 'Mentions',
  'Brand Health': 'Brand Health',
  'Steam All reviews': 'Steam All reviews',
  'Steam All reviews Positive%': 'Steam All reviews Positive%',
  'Steam Added Reviews': 'Steam Added Reviews',
  'Steam Added Positive%': 'Steam Added Positive%',
  famitsu_cumulative_sales: 'Cumulative Sales of the latest week',
  famitsu_revenue: 'Revenue of selected time($)',
  famitsu_cumulative_revenue: 'Cumulative Revenue of the latest week($)',
  famitsu_price: 'Price($)',
  famitsu_sales: 'Sales of selected time',
  databrain__lifetime_total_revenue: 'Lifetime Total Revenue',
  databrain__lifetime_base_game_sales_units: 'Lifetime Base Game Sales Units',
  databrain__total_revenue: 'Total Revenue',
  databrain__base_game_sales_units: 'Base Game Sales Units',
  mscienceLifetimeDigitalRevenue: 'Mscience Lifetime Digital Revenue',
  mscienceLifetimeDigitalUnits: 'Mscience Lifetime Digital Units',
  // Gamalytic metrics
  gamalytic__pcu: 'Gamalytic Steam PCU',
  gamalytic__acu: 'Gamalytic Steam ACU',
  gamalytic__steamfollowers: 'Gamalytic Steam Followers',
  gamalytic__steamreviews: 'Gamalytic Steam Reviews',
  gamalytic__cumulative_reviews: 'Gamalytic Steam Total Reviews',
  gamalytic__est_revenue: 'Gamalytic Steam Revenue($)',
  gamalytic__est_cumulative_revenue: 'Gamalytic Steam Cumulative Revenue($)',
  gamalytic__est_units: 'Gamalytic Steam Units',
  gamalytic__est_cumulative_units: 'Gamalytic Steam Cumulative Units',
  gamalytic__wishlists: 'Gamalytic Steam Daily Wishlist',
  gamalytic__wishlists_total: 'Gamalytic Steam Lifetime Wishlist',
  gamalytic__est_price: 'Gamalytic Steam Price($)',
  gamalytic__lifetime_weighted_price: 'Gamalytic Steam Lifetime Weighted Price($)',
  gamalytic__players_by_country: 'Gamalytic Steam Players by Country',
  gamalytic__playtime: 'Gamalytic Steam Avg.playtime(hours)',
  gamalytic__followers: 'Gamalytic Steam Total Followers',
  // Alinea metrics
  alinea__pcu: 'Alinea Steam PCU',
  alinea__acu: 'Alinea Steam ACU',
  alinea__steamfollowers: 'Alinea Steam Followers',
  alinea__steamreviews: 'Alinea Steam Reviews',
  alinea__players: 'Alinea Steam Players',
  alinea__players_total: 'Alinea Steam Total Players',
  alinea__cumulative_reviews: 'Alinea Steam Total Reviews',
  alinea__positive: 'Alinea Steam Positive Reviews',
  alinea__cumulative_positive: 'Alinea Steam Total Positive Reviews',
  alinea__est_revenue: 'Alinea Steam Revenue($)',
  alinea__est_cumulative_revenue: 'Alinea Steam Cumulative Revenue($)',
  alinea__est_units: 'Alinea Steam Units',
  alinea__est_cumulative_units: 'Alinea Steam Cumulative Units',
  alinea__wishlists: 'Alinea Steam Daily Wishlist',
  alinea__wishlists_total: 'Alinea Steam Lifetime Wishlist',
  alinea__dau: 'Alinea DAU',
  alinea__mau: 'Alinea MAU',
  alinea__est_price: 'Alinea Steam Price($)',
  alinea__lifetime_weighted_price: 'Alinea Steam Lifetime Weighted Price($)',
  alinea__players_by_country: 'Alinea Steam Players by Country',
  alinea__ps_players_by_country: 'Alinea PS Players by Country',
  alinea__wishlists_by_country: 'Alinea Steam Wishlists by Countries',
  alinea__playtime: 'Alinea Steam Avg.playtime(mins)',
  alinea__followers: 'Alinea Steam Total Followers',
  source_steam__pcu: 'Steam PCU',
  source_steam__acu: 'Steam ACU',
  // Console Data (Alinea PS / Xbox)
  alinea__ps_est_revenue: 'Alinea PS Revenue',
  alinea__ps_est_cumulative_revenue: 'Alinea PS Revenue Total',
  alinea__ps_est_units: 'Alinea PS Units',
  alinea__ps_est_cumulative_units: 'Alinea PS Units Total',
  alinea__ps_players: 'Alinea PS Players',
  alinea__ps_players_total: 'Alinea PS Total Players',
  alinea__ps_game_pass_players: 'Alinea PS Game Pass Players',
  alinea__ps_game_pass_players_total: 'Alinea PS Game Pass Total Players',
  alinea__ps_dau: 'Alinea PS DAU',
  alinea__ps_mau: 'Alinea PS MAU',
  alinea__ps_price: 'Alinea PS Price',
  alinea__xbox_est_revenue: 'Alinea Xbox Revenue',
  alinea__xbox_est_cumulative_revenue: 'Alinea Xbox Revenue Total',
  alinea__xbox_est_units: 'Alinea Xbox Units',
  alinea__xbox_est_cumulative_units: 'Alinea Xbox Units Total',
  alinea__xbox_players: 'Alinea Xbox Players',
  alinea__xbox_players_total: 'Alinea Xbox Total Players',
  alinea__xbox_game_pass_players: 'Alinea Xbox Game Pass Players',
  alinea__xbox_game_pass_players_total: 'Alinea Xbox Game Pass Total Players',
  alinea__xbox_dau: 'Alinea Xbox DAU',
  alinea__xbox_mau: 'Alinea Xbox MAU',
  alinea__xbox_price: 'Alinea Xbox Price',
};
export const segmentObj: Record<string, string> = {
  All: 'All',
  'Base Game': 'Full Game',
  'DLC: All Other': 'DLC: All Other',
  'DLC: Expansion': 'DLC: Expansion',
  'DLC: Content Pre-Purchase Pass': 'DLC: Season Pass',
  'DLC: Unlockable Content Pass': 'DLC: Battle Pass',
  MTX: 'MTX',
  Subscription: 'Subscription',
};
export const PC_CONSOLE_GAME_SEGMENT: string[] = [
  'Top Sellers',
  'Most Played',
  'New and Trending',
  'Top Wishlists',
];

export const ampereMetricCommon: { [key: string]: string } = {
  ampere_dau: 'DAU',
  ampere_mau: 'MAU',
  ampere_previous_mau: 'Previous MAU',
  ampere_added_mau: 'Added Users',
  ampere_new_mau: 'New Users',
  ampere_new_dau: 'New Users',
  ampere_retained_mau: 'Retained Users',
  ampere_churned_mau: 'Churned Users',
  ampere_acquisition_rate: 'Acquisition Rate',
  ampere_stickiness: 'Stickiness',
  ampere_lifetime_users: 'Lifetime Players',
  ampere_avg_monthly_playtime: 'Avg Monthly Playtime (hours)',
  ampere_avg_dailly_playtime: 'Avg Dailly Playtime (hours)',
};

export const ampereMetricDay: { [key: string]: string } = {
  ampere_d1: 'D1',
  ampere_d7: 'D7',
  ampere_d14: 'D14',
  ampere_d28: 'D28',
  ampere_d60: 'D60',
  ampere_rolling_d1: 'Rolling D1',
  ampere_rolling_d7: 'Rolling D7',
  ampere_rolling_d14: 'Rolling D14',
  ampere_rolling_d28: 'Rolling D28',
  ampere_rolling_d60: 'Rolling D60',
};

export const ampereMetricMonth: { [key: string]: string } = {
  ampere_d1: 'Monthly D1',
  ampere_d7: 'Monthly D7',
  ampere_d14: 'Monthly D14',
  ampere_d28: 'Monthly D28',
  ampere_d60: 'Monthly D60',
  ampere_rolling_d1: 'Monthly Rolling D1',
  ampere_rolling_d7: 'Monthly Rolling D7',
  ampere_rolling_d14: 'Monthly Rolling D14',
  ampere_rolling_d28: 'Monthly Rolling D28',
  ampere_rolling_d60: 'Monthly Rolling D60',
};

export const PER_FMT_LIST: any = [
  '%',
  'Mobile Overlap',
  'Played&Play%',
  'Played & Wishlist%',
  'Wishlisted & Play%',
  'Wishlisted & Wishlist%',
  'D1',
  'D7',
  'D14',
  'D28',
  'D60',
  'Rolling D1',
  'Rolling D7',
  'Rolling D14',
  'Rolling D28',
  'Rolling D60',
  'D1(no-update)',
  'D2(no-update)',
  'D4(no-update)',
  'D7(no-update)',
  'D7(no-update)',
  'D14(no-update)',
  'D28(no-update)',
  'Acquisition Rate',
  'Stickiness',
];
